export const ADD_PROJECT = 'ADD_PROJECT';
export const SET_PROJECTS = 'SET_PROJECTS =';
export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
export const REMOVE_PROJECT = 'REMOVE_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
